import { defineComponent as n, createBlock as r, openBlock as l, unref as d, mergeProps as p, withCtx as i, createElementVNode as a } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const v = /* @__PURE__ */ n({
  name: "IconAddToCart",
  __name: "IconAddToCart",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (u, e) => (l(), r(d(m), p(t, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        a("path", {
          "fill-rule": "evenodd",
          d: "M11.375 2.25a4.751 4.751 0 0 0-4.691 4H4.875a1.25 1.25 0 0 0-1.25 1.25v11a3.25 3.25 0 0 0 3.25 3.25h4.5a.75.75 0 0 0 0-1.5h-4.5a1.75 1.75 0 0 1-1.75-1.75V7.75h12.5V12a.75.75 0 0 0 1.5 0V7.5a1.25 1.25 0 0 0-1.25-1.25h-1.809a4.751 4.751 0 0 0-4.691-4m0 1.5a3.251 3.251 0 0 0-3.163 2.5h6.326a3.251 3.251 0 0 0-3.163-2.5",
          "clip-rule": "evenodd"
        }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M20.375 17.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-3.5-2a.5.5 0 0 0-1 0V17h-1.5a.5.5 0 0 0 0 1h1.5v1.5a.5.5 0 0 0 1 0V18h1.5a.5.5 0 0 0 0-1h-1.5v-1.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  v as default
};
